<ng-container>
    <render-link [link]="element.settings.general.link" [element]="element">
        <ng-container *ngTemplateOutlet="bgImg"></ng-container>
    </render-link>

    <ng-template #bgImg>
        <button [ngClass]="'button-holder cursor-pointer text-' + element.settings.general.buttonStyles.imageToTextPosition" [style]="style">
            <div class="image">
                <ng-container *ngTemplateOutlet="imageSelector"></ng-container>
            </div>
            <div *ngIf="element.settings && element.settings.general.text" class="wysiwyg" [ngStyle]="style">
                <render-wysiwyg
                    [html]="element.settings.general.text"
                    [element]="element"
                    [textPaddingTop]="element.settings.general.textPaddingTop"
                    [textPaddingBottom]="element.settings.general.textPaddingBottom"
                    [textPaddingLeft]="element.settings.general.textPaddingLeft"
                    [textPaddingRight]="element.settings.general.textPaddingRight"
                >
                </render-wysiwyg>
            </div>
        </button>
    </ng-template>

    <ng-template #imageSelector>
        <ng-container *ngIf="orientation">
            <img
                *ngIf="orientation === 'landscape' && element.settings.general.landscapeImage"
                [src]="element.settings.general.landscapeImage.image"
                [attr.alt]="element.settings.general.alt"
                [attr.title]="element.settings.general.title"
            />
            <img
                *ngIf="orientation === 'portrait' && element.settings.general.portraitImage"
                [src]="element.settings.general.portraitImage.image"
                [attr.alt]="element.settings.general.alt"
                [attr.title]="element.settings.general.title"
            />
        </ng-container>
    </ng-template>
</ng-container>
